module.exports = __webpack_public_path__ + "img/meiwa_kobelco_logo.e736bc37.png";